module.exports = __webpack_public_path__ + "static/plan-s2-7c9e4b45769ea45d14660a5698dc01a2.png";